import { MessageText } from "../../constants/constants.js";

const TEXT = MessageText.statusScreens.tba;

export default function TBAScreen({
  sessionTitle = "this session",
  heading = TEXT.heading,
  noteLabel = TEXT.noteLabel,
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 lg:p-8">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-10 border border-orange-100">
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center border-4 border-white shadow-inner">
            <svg className="w-10 h-10 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl font-black text-gray-900 mb-3 tracking-tight">{heading}</h2>

        <p className="text-gray-500 text-sm mb-8 leading-relaxed">
          The schedule for <span className="font-bold text-gray-800">"{sessionTitle}"</span>{" "}
          is currently being finalized. Please check back soon.
        </p>

        <div className="bg-orange-50 rounded-xl p-4 border border-orange-100 text-center">
          <p className="text-orange-800 text-xs font-semibold uppercase tracking-widest mb-1">{noteLabel}</p>
          <div className="flex justify-center gap-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-1.5 h-1.5 bg-orange-400 rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
